import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__radio_unchecked",
  "use": "general__radio_unchecked-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__radio_unchecked\">\n  <circle cx=\"16\" cy=\"16\" fill=\"none\" r=\"15\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol